import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tab-header',
  templateUrl: './tab-header.component.html',
  styleUrls: ['./tab-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabHeaderComponent {
  @Output()
  toggleFilters: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  refreshElements: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  refreshing: boolean = false;

  @Input()
  headerText?: string;

  @Input()
  hideFilters = false;

  toggleFilterDrawer() {
    this.toggleFilters.emit();
  }

  refreshComponent() {
    this.refreshElements.emit();
  }
}
